import {
  INIT_AGENT_CHAT,
  SETUP_CHAT,
  LOGOUT,
  ADD_USER_CONVERSATION,
  REMOVE_USER_CONVERSATION,
  INSERT_CHAT_ACTIVITY,
  UPDATE_CHAT_TOKEN,
  BIND_CONVERSATION_EVENTS,
  SETUP_UNREAD_MESSAGES,
  SELECT_CHANNEL,
  ON_MESSAGE_ADDED,
  ON_MESSAGE_UPDATED,
  ON_TYPING_STARTED,
  ON_TYPING_ENDED,
  ON_TYPING_MESSAGE,
  LEAVE_CURRENT_CONVERSATION,
  GET_MESSAGES,
  GET_CONVERSATIONS,
  REJECT_CHAT,
  ACCEPT_CHAT,
  NOTIFY_TYPING,
  SEND_MESSAGE,
  GET_RATING,
  TRANSFER_CHAT,
  PROCESS_LOGOUT,
  GET_CHAT_HISTORY,
  GET_MESSAGES_HISTORY,
} from '../../actionTypes';
import { toast } from 'react-toastify';
import {
  FormattedEmail,
  printConsoleLog,
  composeConversation,
  composeMessage,
  playAudio,
  getError,
  setMediaFileName,
  composeFacebookMessage,
  getLanguageWord,
} from '../libs/helper';
import {
  ChannelType,
  ChatStatusMapping,
  ConversationType,
  ParticipantChannelType,
} from '../constants/values';
import { throttle, uniqBy } from 'lodash';
import { Client } from '@twilio/conversations';
import {
  setConnectionStatus,
  setChatActivity,
  clearSelection,
  removeConversation,
  addConversation,
  setConversationStatus,
  setLoader,
  setCurrentConversation,
  setMessages,
  setConversations,
  setUnReadCount,
  setClosedBy,
  removeRequestMessage,
  mapConversationState,
  setTypingInfo,
  setTypingMessage,
  addMessage,
  editMessage,
  setRatingValue,
  setCustomerOnlineStatus,
  setFilter,
  setCustomerOnlineStatusTimeout,
  mapWebChatHistory,
  setMessageHistory,
  setHistorySelectedIndex,
  setHistoryMessages,
  clearCurrentConversation,
} from '../../../features/chat/chatSlice';
import {
  getToken,
  getConversationBySid,
  insertAgentActivity,
  getConversationMessages,
  getAgentConversations,
  updateConversationNote,
  endCustomerChat,
  acceptIncomingChat,
  rejectIncomingChat,
  getRating,
  handOverCustomerChat,
  agentInitChat,
  getChatHistory,
  getMessagesByConversationId,
  getMediaResources,
} from '../../../features/chat/chatAPI';
import { logoutUser } from '../../../features/auth/authAPI';
import { setLoading } from '../../../features/auth/authSlice';

let client = null;
let conversations = [];
let userName = '',
  campaignId = '',
  campaignName;
let conversationJoined = false;
let conversationAgentJoined = false;

const ConversationStatus = {
  Open: 0,
  Closed: 1,
};

let smsCallBack = null;
let smsBulkCallBack = {
  convSids: [],
};

const chatMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    const user = getState().auth.user;
    const languageKeys = user.languageKeys;
    switch (action.type) {
      case SETUP_CHAT: {
        const user = getState().auth.user;
        // const languageKeys = user.languageKeys;
        try {
          console.log(user);
          userName = FormattedEmail(
            user.Email.toLowerCase() ? user.Email.toLowerCase() : '',
            true
          );
          campaignId = user.PrimaryCampaign.id;
          campaignName = user.PrimaryCampaign.name;
          const res = await getToken(userName, campaignId);
          client = new Client(res.token);
          client.on('stateChanged', (state) => {
            let status = state;
            if (state === 'initialized') {
              status = 'connected';
            }
            dispatch(setConnectionStatus(status));
            printConsoleLog('stateChanged', status);
          });
          client.on(
            'conversationJoined',
            throttle((conversation) => {
              printConsoleLog('conversationJoined', conversation);
              dispatch({ type: ADD_USER_CONVERSATION, payload: conversation });
            })
          );
          client.on(
            'conversationLeft',
            throttle((conversation) => {
              printConsoleLog('conversationLeft', conversation);
              dispatch({
                type: REMOVE_USER_CONVERSATION,
                payload: conversation,
              });
            })
          );
          client.on(
            'tokenAboutToExpire',
            throttle(() => {
              printConsoleLog('token abount to expired expired');
              dispatch({ type: UPDATE_CHAT_TOKEN });
            })
          );
          client.on(
            'tokenExpired',
            throttle(() => {
              printConsoleLog('token expired');
              dispatch({ type: UPDATE_CHAT_TOKEN });
            })
          );
          client.on('connectionError', (conn) => {
            printConsoleLog('connectionError', conn);
          });
          client.on('participantLeft', (state) => {
            printConsoleLog('participantLeft', state);
            const index = conversations.findIndex(
              (x) => x.sid == state.conversation.sid
            );
            if (index > -1) {
              const index_temp = getState().chat.conversations.items.findIndex(
                (x) => x.sid == state.conversation.sid
              );
              if (index_temp > -1) {
                dispatch(removeConversation(index_temp));
                dispatch(clearSelection());
              }
              conversations[index].removeAllListeners();
              conversations.splice(index, 1);
            }
          });
          dispatch({
            type: INSERT_CHAT_ACTIVITY,
            payload: ChatStatusMapping.Available,
          });
        } catch (error) {
          printConsoleLog('Chat token get error');
          toast.error(
            getLanguageWord(
              languageKeys.value?.Unable_To_Intialize,
              'Unable to intialize chat. Please check your internet connection or contact support'
            )
          );
          printConsoleLog(error);
        }
        break;
      }
      case UPDATE_CHAT_TOKEN: {
        printConsoleLog('Updating chat token');
        try {
          const res = await getToken(userName, campaignId);
          await client.updateToken(res.token);
          printConsoleLog('Chat token updated');
        } catch (error) {
          printConsoleLog(
            'Chat token not updated. You are disconnected from sms chat'
          );
          toast.error(
            getLanguageWord(
              languageKeys.value?.Chat_Token,
              'Chat token not updated. You are disconnected from sms chat'
            )
          );
          printConsoleLog(error);
        }
        break;
      }
      case ADD_USER_CONVERSATION: {
        const conversation = action.payload;
        const exist = conversations.find((x) => x.sid == conversation.sid);
        if (!exist) {
          conversations.push(conversation);
          printConsoleLog('binding events');
          dispatch({
            type: BIND_CONVERSATION_EVENTS,
            payload: { conversation },
          });
        }
        const sid = `${conversation.sid}`;
        const uniqueName = `${userName}_${conversation.friendlyName}`;
        printConsoleLog(
          `Join event of conversation sid: ${sid}, Unique Name: ${uniqueName}`
        );
        let index;
        index = getState().chat.conversations.items.findIndex(
          (x) => x.sid == sid
        );
        if (index < 0) {
          printConsoleLog('Not found in list using sid');
          printConsoleLog('Adding it');
          try {
            const dbConv = (await getConversationBySid(sid)).data;
            if (dbConv?.id) {
              if (
                conversation.statusSource == 'sync' &&
                dbConv.lastMessage?.body
              ) {
                playAudio();
                // dispatch(
                //   showNotification(dbConv.lastMessage.body, dbConv.friendlyName)
                // );
                toast.info(
                  getLanguageWord(
                    languageKeys.value?.You_Have_Received,
                    'You have received a new message'
                  )
                );
              }
              const c = composeConversation(dbConv);
              if (!conversationJoined) {
                const unread_count =
                  await conversation.getUnreadMessagesCount();
                if (unread_count == null) {
                  const message_count = await conversation.getMessagesCount();
                  if (message_count > 0) {
                    c.unread_messages_count = message_count;
                  }
                }
              }
              dispatch(addConversation(c));
            }
          } catch (error) {
            printConsoleLog(error);
            printConsoleLog(`${sid} getConversationById not found`);
          }
        } else {
          printConsoleLog('found in list updating status');
          dispatch(
            setConversationStatus({
              status: ConversationStatus.Open,
              index,
              sid,
            })
          );
          dispatch({ type: SETUP_UNREAD_MESSAGES, payload: conversation });
        }
        if (conversationJoined) {
          setTimeout(() => {
            dispatch({ type: SELECT_CHANNEL, payload: { sid } });
            if (conversationAgentJoined) {
              dispatch(setFilter('agents'));
              conversationAgentJoined = false;
            } else {
              dispatch(setFilter('active'));
            }
            conversationJoined = false;
          }, 1000);
        }
        if (smsCallBack) {
          dispatch(setLoader(true));
          setTimeout(() => {
            conversation.sendMessage(smsCallBack.message);
            dispatch(setLoader(false));
            smsCallBack = null;
          }, 5000);
        }
        if (smsBulkCallBack[conversation.friendlyName]) {
          setTimeout(() => {
            conversation.sendMessage(
              smsBulkCallBack[conversation.friendlyName]
            );
            smsBulkCallBack[conversation.friendlyName] = null;
          }, 5000);
        }
        break;
      }
      case REMOVE_USER_CONVERSATION: {
        const conversation = action.payload;
        const sid = `${conversation.sid}`;
        const index = conversations.findIndex((x) => x.sid == sid);
        if (index > -1) {
          conversation.removeAllListeners();
          conversations.splice(index, 1);
          const chat = getState().chat;
          const chindex = chat.conversations.items.findIndex(
            (x) => x.sid == sid
          );
          if (chindex > -1) {
            dispatch(
              setConversationStatus({
                status: ConversationStatus.Closed,
                index: chindex,
                sid: sid,
              })
            );
          }
          dispatch(setLoader(false));
        }
        break;
      }
      case SELECT_CHANNEL: {
        const conversation = action.payload;
        const index = getState().chat.conversations.items.findIndex(
          (x) => x.sid == conversation.sid
        );
        if (index > -1) {
          const sid = getState().chat.conversations.items[index].sid;
          printConsoleLog(
            `Selecting conversation index = ${index}, sid = ${sid}`
          );
          dispatch(setCurrentConversation({ index, sid }));
        } else {
          printConsoleLog('Selection not found');
        }
        break;
      }
      case GET_MESSAGES: {
        const {
          selectedChatIndex,
          conversations: convList,
          selectChatSid,
          chatUserId,
        } = getState().chat;
        const user = getState().auth.user;
        if (selectedChatIndex == null) {
          return next(action);
        }
        dispatch(setMessages({ firstLoaded: true, index: selectedChatIndex }));
        const chat_messages = convList.items[selectedChatIndex].messages;
        const conversationType =
          convList.items[selectedChatIndex].conversationType;
        if (chat_messages.hasNextPage) {
          const conv = convList.items.find((x) => x.sid == selectChatSid);
          if (!conv.id) {
            dispatch(
              setMessages({
                isNextPageLoading: false,
                index: selectedChatIndex,
              })
            );
            return next(action);
          }
          dispatch(
            setMessages({ isNextPageLoading: true, index: selectedChatIndex })
          );
          const request = getConversationMessages(
            conv.id,
            chat_messages.pageNo,
            chat_messages.pageSize
          );
          request
            .then((res) => {
              let { messages, totalCount } = res.data;
              messages = messages
                .reverse()
                .map((x) =>
                  composeMessage(
                    x,
                    true,
                    userName,
                    conversationType,
                    `${user.pseudoName}`,
                    chatUserId
                  )
                );
              let data = uniqBy([...messages, ...chat_messages.items], 'sid');
              const hasNextPage =
                messages.length == 0
                  ? false
                  : data.length < totalCount
                  ? true
                  : false;
              let pageNo = hasNextPage
                ? chat_messages.pageNo + 1
                : chat_messages.pageNo;

              dispatch(
                setMessages({
                  pageNo,
                  items: data,
                  total: totalCount,
                  isNextPageLoading: false,
                  hasNextPage,
                  index: selectedChatIndex,
                })
              );

              const cconv = conversations.find((x) => x.sid == selectChatSid);
              if (cconv && data.length > 0) {
                printConsoleLog('Marking all msg as read');
                cconv.setAllMessagesRead().then((r) => console.log(r));
              }
            })
            .catch((error) => {
              printConsoleLog('error in conversations get', error);
              dispatch(
                setMessages({
                  isNextPageLoading: false,
                  hasNextPage: true,
                  index: selectedChatIndex,
                })
              );
              toast.error(
                getLanguageWord(
                  languageKeys.value?.Some_Error_Occurred,
                  'Some error occurred while getting messages'
                )
              );
              if (error.response?.data.errors) {
                toast.error(getError(error.response.data));
              }
            });
        }
        break;
      }
      case GET_MESSAGES_HISTORY: {
        const { conversationId, showSpecificConversation } = action.payload;
        const { selectedChatIndex, history, chatUserId, conversations } =
          getState().chat;

        const visitorId = conversations.items[selectedChatIndex].visitorId;
        const historyByVisitorId = history.items.filter(
          (x) => x.visitorId == visitorId
        );

        const user = getState().auth.user;
        if (selectedChatIndex != null) {
          var index = historyByVisitorId.findIndex(
            (x) => x.conversationId == conversationId
          );
          if (!showSpecificConversation) {
            index += 1;
          }
          dispatch(setHistorySelectedIndex(index));
          const conversationSid = historyByVisitorId[index].conversationSid;
          const conversationType = historyByVisitorId[index].conversationType;
          const chat_messages = historyByVisitorId[index].messages.items;
          let updates = {};
          //if (history.hasNextPage) {
          dispatch(
            setMessageHistory({ isNextPageLoading: true, firstLoaded: true })
          );
          const request = getMessagesByConversationId(
            conversationSid,
            historyByVisitorId[index].messages.pageNo,
            historyByVisitorId[index].messages.pageSize
          );
          request
            .then((res) => {
              let { messages, totalCount } = res.data;
              messages = messages
                .reverse()
                .map((x) =>
                  composeMessage(
                    x,
                    true,
                    userName,
                    conversationType,
                    `${user.pseudoName}`,
                    chatUserId
                  )
                );
              let data = [...messages, ...chat_messages];
              const hasNextPage = data.length < totalCount;
              let pageNo = hasNextPage
                ? historyByVisitorId[index].messages.pageNo + 1
                : historyByVisitorId[index].messages.pageNo;
              dispatch(
                setMessageHistory({
                  isNextPageLoading: false,
                  items: data,
                  total: totalCount,
                  hasNextPage,
                  pageNo,
                })
              );
              dispatch(
                setHistoryMessages(historyByVisitorId[index].conversationId)
              );
            })
            .catch((error) => {
              printConsoleLog('error in message by btn get', error);
              dispatch(
                setMessageHistory({
                  hasNextPage: true,
                  isNextPageLoading: false,
                })
              );
            });
          //}
        }
        break;
      }
      case GET_CHAT_HISTORY: {
        const conversationId = action.payload;
        const request = getChatHistory(conversationId);
        request
          .then((res) => {
            dispatch(mapWebChatHistory(res.data));
          })
          .catch((error) => {
            printConsoleLog('error in chat history get', error);
            toast.error(
              getLanguageWord(
                languageKeys.value?.Some_Error_Occurred_Web,
                'Some error occurred while getting web chat history'
              )
            );
            if (error.response?.data.errors) {
              toast.error(getError(error.response.data));
            }
          });
        break;
      }
      case GET_CONVERSATIONS: {
        const user = getState().auth.user;
        const conversation = getState().chat.conversations;
        const { searchValue, pageNo, firstLoad, channelType, campaignIds } =
          action.payload;
        const updates = {
          isNextPageLoading: true,
          hasNextPage: false,
          searchValue,
          pageNo,
          channelType,
          selectedChatIndex: null,
          selectChatSid: null,
        };
        if (searchValue) {
          updates.items = [];
        }
        if (conversation.channelType != channelType) {
          updates.items = [];
        }
        dispatch(setLoader(true));
        dispatch(setConversations(updates));
        const request = getAgentConversations(
          user.Email,
          searchValue,
          pageNo,
          conversation.pageSize,
          channelType,
          campaignIds,
          user.Id
        );
        request
          .then((res) => {
            dispatch(setLoader(false));
            let data = getState().chat.conversations.items;
            let newOne = [];
            if (data.length > 0) {
              res.data.conversations.forEach((c) => {
                const index = data.findIndex(
                  (x) => x.uniqueName == c.uniqueName
                );
                if (index == -1) {
                  newOne.push(c.conversationSid);
                }
              });
            }
            dispatch(mapConversationState(res.data));

            if (firstLoad) {
              dispatch({ type: SETUP_CHAT });
            } else {
              if (newOne.length > 0) {
                setTimeout(() => {
                  newOne.forEach((d) => {
                    const c = conversations.find((x) => x.sid == d);
                    if (c) {
                      printConsoleLog(
                        `looking for unread messages for :: ${d}`
                      );
                      dispatch({ type: SETUP_UNREAD_MESSAGES, payload: c });
                    }
                  });
                }, 1000);
              }
            }
          })
          .catch((error) => {
            dispatch(setLoader(false));
            printConsoleLog('error in conversations get', error);
            dispatch(
              setConversations({ hasNextPage: true, isNextPageLoading: false })
            );
            toast.error(
              getLanguageWord(
                languageKeys.value?.Some_Error_Occurred_Conver,
                'Some error occurred while getting conversations'
              )
            );
            if (error.response?.data.errors) {
              toast.error(getError(error.response.data));
            }
          });
        break;
      }
      case SETUP_UNREAD_MESSAGES: {
        const conversation = action.payload;
        const { selectedChatIndex, conversations: convlist } = getState().chat;
        const index = convlist.items.findIndex(
          (x) => x.sid == conversation.sid
        );
        if (index > -1) {
          if (selectedChatIndex !== index) {
            const unread_count = await conversation.getUnreadMessagesCount();
            if (unread_count == null) {
              const message_count = await conversation.getMessagesCount();
              if (message_count > 0) {
                dispatch(setUnReadCount({ index, count: message_count }));
              }
            } else {
              dispatch(setUnReadCount({ index, count: unread_count }));
            }
          }
        }
        break;
      }
      case LEAVE_CURRENT_CONVERSATION: {
        const data = action.payload;
        const chat = getState().chat;
        const sid = chat.conversations.items[chat.selectedChatIndex].sid;
        const conv = conversations.find((x) => x.sid == sid);
        let request;
        if (!conv) {
          request = updateConversationNote(
            sid,
            data.title,
            data.notes,
            data.disposition
          );
        } else {
          const participant = await conv.getParticipantByIdentity(userName);
          request = endCustomerChat(
            sid,
            participant.sid,
            userName,
            data.disposition,
            data.title,
            data.notes
          );
        }
        dispatch(setLoader(true));
        request
          .then((res) => {
            const items = getState().chat.conversations.items;
            const index = items.findIndex((x) => x.sid == sid);
            dispatch(setLoader(false));
            if (data.hasDisposition) {
              toast.success(
                `${items[index].nickName} ${getLanguageWord(
                  languageKeys.value?.Marked_Closed,
                  'marked 🔒 closed successfully'
                )} `
              );
            } else {
              toast.success(
                getLanguageWord(
                  languageKeys.value?.Chat_Disposition,
                  'Chat disposition updated'
                )
              );
            }

            dispatch(
              setClosedBy({
                index: chat.selectedChatIndex,
                closedBy: 2,
                hasDisposition: true,
                dateClosed: new Date().toISOString(),
                disposition: {
                  name: data.disposition,
                },
                note: {
                  title: data.title,
                  name: data.notes,
                },
              })
            );
          })
          .catch((error) => {
            printConsoleLog('error on updateConversationNote', error);
            dispatch(setLoader(false));
            toast.error(
              getLanguageWord(
                languageKeys.value?.Chat_Cannot_Completed,
                'Chat cannot be completed at the moment.'
              )
            );
            if (error.response.data.errors) {
              toast.error(getError(error.response.data));
            }
          });
        break;
      }
      case BIND_CONVERSATION_EVENTS: {
        const customerGoOnline = (sid) => {
          dispatch(setCustomerOnlineStatus({ sid, online: true }));
        };

        const customerGoAway = (sid) => {
          const conv = getState().chat.conversations.items.find(
            (x) => x.sid === sid
          );

          if (conv && conv.customerOnlineStatusTimeout)
            clearTimeout(conv.customerOnlineStatusTimeout);

          const customerOnlineStatusTimeout = setTimeout(() => {
            dispatch(
              setCustomerOnlineStatus({
                sid,
                online: false,
              })
            );
          }, +process.env.REACT_APP_CUSTOMER_ONLINE_STATUS_TIMEOUT * 1000);

          dispatch(
            setCustomerOnlineStatusTimeout({
              sid,
              customerOnlineStatusTimeout,
            })
          );
        };
        const { conversation } = action.payload;
        customerGoAway(conversation.sid);
        printConsoleLog('Binding conversation events');
        conversation.on('messageAdded', (message) => {
          if (message.author !== userName) customerGoOnline(conversation.sid);

          dispatch({ type: ON_MESSAGE_ADDED, payload: message });

          if (message.author !== userName) customerGoAway(conversation.sid);
        });
        conversation.on('messageUpdated', (updates) => {
          printConsoleLog('message updated', updates);
          printConsoleLog(
            'message updated in JSON stringify',
            JSON.stringify(updates.message.state.aggregatedDeliveryReceipt)
          );
          dispatch({
            type: ON_MESSAGE_UPDATED,
            payload: { message: updates.message },
          });
        });
        conversation.on('updated', (state) => {
          printConsoleLog('conversation updated', state);
          if (
            state.updateReasons.indexOf('attributes') < 0 ||
            !state.conversation.channelState.attributes?.customerMessage
          )
            return;

          // customerGoOnline(conversation.sid);
          let message =
            state.conversation.channelState.attributes?.customerMessage;
          dispatch({
            type: ON_TYPING_MESSAGE,
            payload: {
              message: message,
              channel: conversation,
            },
          });
        });
        conversation.on('typingStarted', (member) => {
          customerGoOnline(conversation.sid);
          dispatch({
            type: ON_TYPING_STARTED,
            payload: {
              typing: { on: true, user: member.identity },
              channel: conversation,
            },
          });
        });
        conversation.on('typingEnded', (member) => {
          dispatch({
            type: ON_TYPING_ENDED,
            payload: { typing: { on: false, user: '' }, channel: conversation },
          });

          customerGoAway(conversation.sid);
        });
        setTimeout(async () => {
          const participants = await conversation.getParticipants();
          const customer = participants.filter((x) => x.identity != userName);
          customer.forEach(async (c) => {
            if (c.state.type !== 'sms' && c.state.type !== 'whatsapp') {
              const user = await c.getUser();
              if (user) {
                dispatch(
                  setCustomerOnlineStatus({
                    sid: conversation.sid,
                    online: user.isOnline,
                  })
                );
                user.on('updated', (state) => {
                  printConsoleLog('user updated', state);
                  dispatch(
                    setCustomerOnlineStatus({
                      sid: conversation.sid,
                      online: state.user.isOnline,
                    })
                  );
                });
              }
            }
          });
        }, 2000);
        break;
      }
      case INSERT_CHAT_ACTIVITY: {
        const user = getState().auth.user;
        const newActivity = action.payload;
        const oldActivity = getState().chat.currentActivity;
        printConsoleLog('Inseting chat activity', oldActivity, newActivity);
        insertAgentActivity(
          oldActivity,
          newActivity,
          user.Email,
          campaignName,
          campaignId
        )
          .then((res) => {
            dispatch(setChatActivity(newActivity));
            dispatch(setLoader(false));
          })
          .catch((err) => {
            dispatch(setLoader(false));
            printConsoleLog('Error in inserting chat activity', err);
          });
        break;
      }
      case ACCEPT_CHAT: {
        const data = action.payload;
        const user = getState().auth.user;
        dispatch(setLoader(true));
        const index = getState().chat.requests.findIndex(
          (x) => x.CustomerConversationSid == data.CustomerConversationSid
        );
        acceptIncomingChat(
          data.CustomerConversationSid,
          userName,
          `${user.FirstName} ${user.LastName}`,
          user.Email,
          user.UserImage,
          user.ID
        )
          .then((res) => {
            conversationJoined = true;
            toast.success(
              `${data.FriendlyName} ${getLanguageWord(
                languageKeys.value?.Chat_Accepted,
                'chat accepted'
              )}`
            );
            dispatch(setLoader(false));
            if (index > -1) {
              dispatch(removeRequestMessage(index));
            }
          })
          .catch((error) => {
            printConsoleLog('Error in ACCEPT_CHAT', error);
            dispatch(setLoader(false));
            if (error.response.data.errors) {
              printConsoleLog(error.response.data);
              if (index > -1) {
                dispatch(removeRequestMessage(index));
              }
              toast.error(getError(error.response.data));
            }
          });
        break;
      }
      case REJECT_CHAT: {
        const data = action.payload;
        const user = getState().auth.user;
        dispatch(setLoader(true));
        const index = getState().chat.requests.findIndex(
          (x) => x.CustomerConversationSid == data.CustomerConversationSid
        );
        rejectIncomingChat(
          data.CustomerConversationSid,
          userName,
          `${user.FriendlyName} ${user.LastName}`,
          user.Email,
          user.UserImage,
          user.ID
        )
          .then((res) => {
            dispatch(setLoader(false));
            if (index > -1) {
              dispatch(removeRequestMessage(index));
            }
          })
          .catch((error) => {
            printConsoleLog('Error in REJECT_CHAT', error);
            dispatch(setLoader(false, ''));
            if (error.response.data.errors) {
              printConsoleLog(error.response.data);
              if (index > -1) {
                dispatch(removeRequestMessage(index));
              }
              toast.error(getError(error.response.data));
            }
          });
        break;
      }
      case TRANSFER_CHAT: {
        const data = action.payload;
        const chat = getState().chat;

        if (chat.selectedChatIndex == null) {
          toast.error(
            getLanguageWord(
              languageKeys.value?.Please_Select_Transfer,
              'Please select conversation to tranfer'
            )
          );
          return next(action);
        }


        if(data.campaign.indexOf(chat.conversations.items[chat.selectedChatIndex].campaignId) < 0) {
          toast.error(
            getLanguageWord(
              languageKeys.value?.Cannot_Tranfer_Chat_Different_Campaign,
              'Can not transfer chat to different campaign.'
            )
          );
          return next(action);
        }
        
        if (
          chat.conversations.items[chat.selectedChatIndex].status ==
          ConversationStatus.Closed
        ) {
          toast.error(
            getLanguageWord(
              languageKeys.value?.Conversation_Closed_State,
              'Conversation already is in closed state'
            )
          );
          return next(action);
        }
        if (
          chat.conversations.items[chat.selectedChatIndex].conversationType ==
          ConversationType.Agent
        ) {
          toast.error(
            getLanguageWord(
              languageKeys.value?.You_Cannot_Transfer,
              'You cannot transfer agent chat'
            )
          );
          return next(action);
        }
        const sid = chat.conversations.items[chat.selectedChatIndex].sid;
        const conv = conversations.find((x) => x.sid == sid);
        if (!conv) {
          toast.error(
            getLanguageWord(
              languageKeys.value?.Active_Conversation,
              'Active conversation not found'
            )
          );
          return next(action);
        }
        try {
          dispatch(setLoader(true));
          const participant = await conv.getParticipantByIdentity(userName);
          handOverCustomerChat(sid, data.identity, data, participant.sid)
            .then((res) => {
              dispatch(setLoader(false));
              toast.success(
                getLanguageWord(
                  languageKeys.value?.Chat_Transfered,
                  'Chat transfered successfully.'
                )
              );
              dispatch(clearCurrentConversation());
            })
            .catch((error) => {
              printConsoleLog('Error in TRANSFER_CHAT', error);
              dispatch(setLoader(false));
              if (error.response?.data.errors) {
                printConsoleLog(error.response?.data);
                toast.error(getError(error.response.data));
              }
            });
        } catch (error) {
          toast.error(
            getLanguageWord(
              languageKeys.value?.Participant_Notfound,
              'Participant not found'
            )
          );
          return next(action);
        }
        break;
      }
      case NOTIFY_TYPING: {
        const index = action.payload;
        const sid = getState().chat.conversations.items[index].sid;
        const conversation = conversations.find((x) => x.sid == sid);
        if (conversation) {
          conversation.typing();
        }
        break;
      }
      case SEND_MESSAGE: {
        const chat = getState().chat;
        if (chat.connectionStatus.toLowerCase() !== 'connected') {
          toast.warning(
            getLanguageWord(
              languageKeys.value?.Chat_System,
              'Chat System is not connected. Please check your internet and try again'
            )
          );
          return next(action);
        }
        if (chat.selectedChatIndex != null) {
          const conv = chat.conversations.items[chat.selectedChatIndex];
          if (conv.status == ConversationStatus.Closed) {
            console.log('Conv is closed');
          } else {
            const currentChannel = conversations.find((x) => x.sid == conv.sid);
            if (currentChannel) {
              if (typeof action.payload == 'string') {
                currentChannel.sendMessage(action.payload);
              } else {
                const pipeline = await currentChannel.prepareMessage();
                const medias = action.payload;
                for (let i = 0; i < medias.length; i++) {
                  pipeline.addMedia(medias[i]);
                }
                pipeline.build().send();
              }
            }
          }
        }
        break;
      }
      case ON_MESSAGE_ADDED: {
        const user = getState().auth.user;
        const { selectChatSid, selectedChatIndex, chatUserId } =
          getState().chat;
        const message = action.payload;
        printConsoleLog(
          `Message added of conversation sid: ${message.conversation.sid}`,
          message
        );
        const convlist = getState().chat.conversations;
        const primaryCampaign = getState().auth.user.PrimaryCampaign.id;
        const index = convlist.items.findIndex(
          (x) => x.sid == message.conversation.sid
        );
        if (index > -1) {
          const channelType = convlist.items[index].channelType;
          const conversationType = convlist.items[index].conversationType;
          const direction =
            FormattedEmail(message.state.author.toLowerCase(), true) == userName
              ? 'outgoing'
              : 'incoming';
          if (
            channelType === ParticipantChannelType.Facebook &&
            !message.state.body &&
            direction == 'incoming'
          ) {
            //message.state.medias = await setMediaFileName(message.state.medias);
            getMediaResources(primaryCampaign, message.sid)
              .then((res) => {
                const m = composeFacebookMessage(
                  message.state,
                  false,
                  userName,
                  conversationType,
                  `${user.pseudoName}`,
                  chatUserId,
                  res.data
                );
                dispatch(addMessage({ message: m, index }));
                if (m.direction == 'incoming') {
                  //if(!selectChatSid || selectChatSid != message.conversation.sid) {
                  playAudio();
                  //dispatch(showNotification(m.body, m.username));
                  toast.info(
                    getLanguageWord(
                      languageKeys.value?.You_Have_Received,
                      'You have received a new message'
                    )
                  );
                }
              })
              .catch((error) => {});
          } else {
            if (message.state.medias && message.state.medias.length > 0) {
              message.state.medias = await setMediaFileName(
                message.state.medias
              );
            }
            const m = composeMessage(
              message.state,
              false,
              userName,
              conversationType,
              `${user.pseudoName}`,
              chatUserId
            );
            dispatch(addMessage({ message: m, index }));

            if (m.direction == 'incoming') {
              //if(!selectChatSid || selectChatSid != message.conversation.sid) {
              playAudio();
              //dispatch(showNotification(m.body, m.username));
              toast.info(
                getLanguageWord(
                  languageKeys.value?.You_Have_Received,
                  'You have received a new message'
                )
              );
            }
          }
          if (index == selectedChatIndex) {
            const cconv = conversations.find((x) => x.sid == selectChatSid);
            if (cconv) {
              printConsoleLog(
                `Updating last read index of conv: ${selectChatSid}`,
                cconv
              );
              cconv.setAllMessagesRead().then((r) => console.log(r));
            }
          }
        }
        break;
      }
      case ON_MESSAGE_UPDATED: {
        const { message } = action.payload;
        const chat = getState().chat;
        const ch_index = chat.conversations.items.findIndex(
          (x) => x.sid == message.conversation.sid
        );
        if (ch_index > -1) {
          const msg_index = chat.conversations.items[
            ch_index
          ].messages.items.findIndex((x) => x.sid == message.state.sid);
          if (msg_index > -1) {
            dispatch(
              editMessage({
                ch_index,
                msg_index,
                attributes: message.state.attributes,
                receipt: message.state.aggregatedDeliveryReceipt?.state,
                lastMessageTime: message.state.dateUpdated.toISOString(),
              })
            );
          }
        }
        break;
      }
      case GET_RATING: {
        const convId =
          getState().chat.conversations.items[getState().chat.selectedChatIndex]
            .sid;
        dispatch(setLoader(true));
        getRating(convId)
          .then((res) => {
            const { questions, feedback } = res.data;
            const rating = {
              Satisfy: questions[0].rating,
              Knowledge: questions[1].rating,
              Friendly: questions[2].rating,
              Responsive: questions[3].rating,
              Additional: feedback,
            };
            dispatch(setRatingValue(rating));
          })
          .catch((error) => {
            printConsoleLog('Error in GET_RATING', error);
            dispatch(setLoader(false, ''));
            if (error.response?.data.errors) {
              printConsoleLog(error.response.data);
              toast.error(getError(error.response.data));
            }
          });
        break;
      }
      case ON_TYPING_STARTED:
      case ON_TYPING_ENDED: {
        // debugger;
        const { typing, channel } = action.payload;
        const index = getState().chat.conversations.items.findIndex(
          (x) => x.sid == channel.sid
        );
        if (index > -1) {
          dispatch(setTypingInfo({ typing, index }));
        }
        break;
      }
      case ON_TYPING_MESSAGE: {
        const { message, channel } = action.payload;
        const index = getState().chat.conversations.items.findIndex(
          (x) => x.sid == channel.sid
        );
        if (index > -1) {
          dispatch(setTypingMessage({ message, index }));
        }
        break;
      }
      case PROCESS_LOGOUT:
        const user = getState().auth.user;
        if (user.Role == 'Agent') {
          const conv = getState().chat.conversations.items;
          if (
            conv.filter(
              (x) =>
                x.status == ConversationStatus.Open &&
                x.channelType == ChannelType.Web &&
                x.conversationType != ConversationType.Agent
            ).length > 0
          ) {
            toast.error(
              getLanguageWord(
                languageKeys.value?.There_Are_Pending_Chats,
                'There are pending web chats, Please mark them closed.'
              )
            );
            return next(action);
          }
          await dispatch({
            type: INSERT_CHAT_ACTIVITY,
            payload: ChatStatusMapping.Offline,
          });
        }
        dispatch(setLoading(true));
        setTimeout(() => {
          dispatch(logoutUser());
        }, 500);
        break;
      case LOGOUT:
        if (client) {
          client.removeAllListeners();
          client.shutdown();
        }
        conversations.forEach(async (channel) => {
          await channel.removeAllListeners();
        });
        client = null;
        conversations = [];
        break;
      case INIT_AGENT_CHAT:
        dispatch(setLoader(true));
        conversationJoined = true;
        conversationAgentJoined = true;
        agentInitChat(action.payload)
          .then((res) => {
            dispatch(setLoader(false));
            toast.success(
              getLanguageWord(
                languageKeys.value?.Chat_Initiated,
                'Chat initiated with agent successfully.'
              )
            );
            console.log('agentInitChat res :>> ', res);
          })
          .catch((error) => {
            conversationJoined = false;
            conversationAgentJoined = false;
            printConsoleLog('Error in INIT_AGENT_CHAT', error);
            dispatch(setLoader(false));
            if (error.response?.data.errors) {
              printConsoleLog(error.response?.data);
              toast.error(getError(error.response.data));
            }
          });
        break;
      default:
        break;
    }
    return next(action);
  };

export default chatMiddleware;
